var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Inset } from 'syf-component-library/ui/spacing';
import Select from 'syf-component-library/ui/atoms/Select';
import formatUserAnswer from '../../../helpers/formatUserAnswer';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { updateUserAnswers } from '../../../redux/userAnswers/userAnswers.slice';
import { clearFormError } from '../../../redux/ui/ui.slice';
import getCurrentQuestionAnswer from '../../../helpers/getCurrentQuestionAnswer';
import { t } from '../../../strings/i18n/i18n';
import triggerAnalyticsEvent, { Analytics } from '../../../helpers/analyticsMiddleware';
import Icon from '../Icon';
import AdditionalContent from '../AdditionalContent';
var Dropdown = function (_a) {
    var answer = _a.answer;
    var dropDownOptions = answer.answerOptions.map(function (data) { return ({
        label: data.answerOption,
        value: data.nextQuestionId,
        answerId: data.answerId,
        disputeReason: data.disputeReason,
        additionalContent: data.additionalContent,
        metadata: data.metadata,
        script: data.script
    }); });
    var _b = useSelector(function (state) { return state; }, shallowEqual), formError = _b.ui.formError, userAnswers = _b.userAnswers, currentQuestion = _b.questionnaire.currentQuestion;
    var dispatch = useDispatch();
    var textfieldRef = useRef(null);
    var selectRef = useRef(null);
    var currentQuestionAnswer = getCurrentQuestionAnswer({
        userAnswers: userAnswers,
        currentQuestion: currentQuestion
    });
    var answerIndex = currentQuestionAnswer &&
        answer.answerOptions.findIndex(function (data) { return data.answerOption === currentQuestionAnswer.answers[0]; });
    var defaultOption = answerIndex
        ? dropDownOptions[answerIndex]
        : dropDownOptions[0];
    var hasAdditionalContent = defaultOption.additionalContent;
    var formatAndDispatchAnswer = function (option) {
        var additionalContent = '';
        var optionData = [option.label];
        if ((option === null || option === void 0 ? void 0 : option.additionalContent) && additionalContent) {
            optionData.push(additionalContent);
        }
        var payload = formatUserAnswer({
            nextQuestionId: option.value,
            answerId: option.answerId,
            option: optionData,
            currentQuestion: currentQuestion,
            disputeReason: option.disputeReason,
            script: option.script,
            type: 'DROPDOWN'
        });
        return dispatch(updateUserAnswers(payload));
    };
    var handleOnChange = function (options) {
        triggerAnalyticsEvent({
            PageKind: Analytics.Dispute,
            PageFunction: Analytics.Billing,
            PageSubFunction: options === null || options === void 0 ? void 0 : options.label,
            pageName: Analytics.Questionnaire
        });
        dispatch(clearFormError());
        formatAndDispatchAnswer(options);
        if (hasAdditionalContent && (textfieldRef === null || textfieldRef === void 0 ? void 0 : textfieldRef.current)) {
            textfieldRef.current.focus();
        }
    };
    useEffect(function () {
        if (!dropDownOptions[answerIndex]) {
            formatAndDispatchAnswer(defaultOption);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return (_jsxs(Inset, __assign({ bottom: "xxlarge" }, { children: [_jsx(Select, { error: !(defaultOption && hasAdditionalContent) && formError, errorIcon: _jsx(Icon, { name: "faExclamationCircle", size: "sm" }), name: "Default Select", id: "disputes-select", placeholder: "".concat(t('dropDown.placeholder')), options: dropDownOptions, defaultOption: defaultOption, rightIconOpen: _jsx(Icon, { name: "faChevronUp", size: "1x" }), rightIconClosed: _jsx(Icon, { name: "faChevronDown", size: "1x" }), required: true, onChange: handleOnChange, selectInputRef: selectRef }), hasAdditionalContent ? (_jsx(AdditionalContent, { textfieldRef: textfieldRef, answerMetadata: defaultOption.metadata })) : null] })));
};
export default Dropdown;
//# sourceMappingURL=index.js.map